import MonthCalendar from "../components/MonthCalendar";
import { Reveal, MaskLine } from "../components/Reveal";

export default function BookStudioPage() {
  return (
    <main className="pt-[72px]" data-testid="book-studio-page">
      <section className="py-20 sm:py-28 border-t border-[#27272a]">
        <div className="max-w-[1400px] mx-auto px-5 sm:px-8">
          <div className="grid lg:grid-cols-12 gap-8 items-end mb-14">
            <div className="lg:col-span-8">
              <span className="font-mono text-xs uppercase tracking-[0.2em] text-gold">[ SEC Studios · Studio Hire ]</span>
              <h1 className="font-display text-4xl sm:text-6xl lg:text-7xl font-semibold uppercase tracking-tighter leading-[0.9] mt-5">
                <MaskLine>Book The</MaskLine>
                <MaskLine delay={0.1} className="text-gold">Studio</MaskLine>
              </h1>
            </div>
            <div className="lg:col-span-4">
              <p className="text-zinc-400 leading-relaxed">
                Choose a day, pick an available 1-hour slot and send your request.
                Studio hire is arranged on a commission basis — we'll confirm the
                details by email. Open Mon–Sun, 9am–7pm.
              </p>
            </div>
          </div>

          <Reveal>
            <MonthCalendar />
          </Reveal>
        </div>
      </section>
    </main>
  );
}
